import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-patient-overview-version-dialog',
    templateUrl: './patient-overview-version-dialog.component.html',
    styleUrls: ['./patient-overview-version-dialog.component.scss'],
    standalone: false
})
export class PatientOverviewVersionDialogComponent {
  constructor(private dialogRef: MatDialogRef<PatientOverviewVersionDialogComponent>) {}

  select(choice: 'old' | 'new'): void {
    this.dialogRef.close(choice);
  }
}

